module.exports = __webpack_public_path__ + "img/cns_ios17.30b449fb.png";